document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
          var pageType= ShopifyAnalytics.meta.page.pageType;
  if(pageType =="product"){
  let selectInput = document.querySelector("#pandaSelect13");  
   if(selectInput){
     selectInput.value="all";
     selectInput.style.display="none"
   }
   
   const prevElement = selectInput.previousElementSibling;
  if (prevElement) {
    prevElement.style.display = "none";
  }

  }
    }, 2000);
  
});

